import { BFF_BASE_URL } from './api';

export interface VitalPayload {
  name: string;
  value: number;
  route: string;
  rating: 'good' | 'needs-improvement' | 'poor';
  nav_type: string;
}

const VITALS_URL = `${BFF_BASE_URL}/telemetry/vitals`;
const MAX_VALUE = 600_000;
const MAX_ROUTE_LENGTH = 200;

export function sendVital(payload: VitalPayload): void {
  if (process.env.NODE_ENV !== 'production') return;
  if (!(payload.value >= 0 && payload.value <= MAX_VALUE)) return;
  const body = JSON.stringify({ ...payload, route: payload.route.slice(0, MAX_ROUTE_LENGTH) });
  if (navigator.sendBeacon?.(VITALS_URL, body)) return;
  fetch(VITALS_URL, {
    method: 'POST',
    body,
    keepalive: true,
    headers: { 'Content-Type': 'text/plain' },
  }).catch(() => undefined);
}
